import { IFeedItem } from '@app/models/FeedItem'
import { ICurrentUserState } from '@app/store/modules/account'
import * as React from 'react'
import { actionCreators } from '../modules/feedItems'
import './FeedItem.scss'
import FeedItemBody from './FeedItemBody'
import FeedItemEditBody from './FeedItemEditBody'
import FeedItemFooter from './FeedItemFooter'
import FeedItemHeader from './FeedItemHeader'

export interface IFeedItemUIProps {
  feedItemId: string
  onLayoutChanged?: () => void
}

export interface IFeedItemModuleProps {
  item: IFeedItem
}

type FeedItemProps = IFeedItemUIProps &
  IFeedItemModuleProps &
  ICurrentUserState &
  typeof actionCreators

export default class FeedItem extends React.Component<FeedItemProps> {
  private clientHeight: number
  private feedItemRef: React.RefObject<HTMLDivElement>

  constructor(props: FeedItemProps) {
    super(props)

    this.feedItemRef = React.createRef()
    this.clientHeight = 0
  }

  public componentDidMount() {
    if (this.feedItemRef.current) {
      this.clientHeight = this.feedItemRef.current.clientHeight
    }
  }

  public componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
    if (this.feedItemRef.current) {
      if (this.clientHeight !== this.feedItemRef.current.clientHeight) {
        this.clientHeight = this.feedItemRef.current.clientHeight
        if (this.props.onLayoutChanged && this.props.item.id) {
          this.props.onLayoutChanged()
        }
      }
    }
  }

  public render() {
    if (!this.props.item.id) {
      return null
    }

    return (
      <div className='px-2 pb-2'>
        <div
          className='feed-item shadow bg-white rounded'
          ref={this.feedItemRef}
        >
          <FeedItemHeader
            archiveLead={this.props.archiveLead}
            beginEdit={this.props.beginEdit}
            deleteFeedItem={this.props.deleteFeedItem}
            item={this.props.item}
            user={this.props.user}
            saveChangeType={this.props.saveChangeType}
            showShareFeedItemModal={this.props.showShareFeedItemModal}
          />
          {this._renderBody()}
          <FeedItemFooter
            item={this.props.item}
            onLayoutChanged={this.props.onLayoutChanged}
            loadComments={this.props.loadComments}
            toggleFeedItemFavorite={this.props.toggleFeedItemFavorite}
            toggleShowComments={this.props.toggleShowComments}
          />
        </div>
      </div>
    )
  }

  private _renderBody() {
    if (this.props.item.isEditing) {
      return (
        <FeedItemEditBody
          cancelEdit={this.props.cancelEdit}
          item={this.props.item}
          onLayoutChanged={this.props.onLayoutChanged}
          saveEdit={this.props.saveEditFeedItem}
          setEditIsPublic={this.props.setEditIsPublic}
          setEditLeadPriority={this.props.setEditLeadPriority}
          setEditLeadType={this.props.setEditLeadType}
          setEditMarkup={this.props.setEditMarkup}
          setEditTitle={this.props.setEditTitle}
        />
      )
    } else {
      return (
        <FeedItemBody
          item={this.props.item}
          setSelectedPhoto={this.props.setSelectedPhoto}
        />
      )
    }
  }
}
